const update_sql3 = [
    `drop table if exists t_msg;`,
    'create table t_msg(' +
        'mid PRIMARY KEY, tid, tmid, cid, sender,' +
        'stime, type, content, meta, etime,' +
        'target_cnt, target_uids, read_cnt, read_uids, at_cnt,' +
        'at_uids, atread_cnt, atread_uids, mask, visible,' +
        'audit_word, audit_rst, audit_mid, lbatchid, lutime,' +
        'lctime, latme)',
];

export default update_sql3;
